import { Component, effect, model, output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { sanitizeFields, watchFormRecursively } from '../../../shared/utils/form-utils';

import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormFieldFeedbackPipe } from '../../../pipes/form-field-feedback/form-field-feedback.pipe';
import { InputMaskModule } from 'primeng/inputmask';
import { InputText } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { NgClass } from '@angular/common';
import { PasswordModule } from 'primeng/password';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TooltipModule } from 'primeng/tooltip';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-forgot-password-form',
  imports: [
    ButtonModule,
    InputText,
    DatePickerModule,
    PasswordModule,
    InputMaskModule,
    FormFieldFeedbackPipe,
    TooltipModule,
    ReactiveFormsModule,
    FormsModule,
    ToggleSwitchModule,
    FloatLabelModule
  ],
  templateUrl: './forgot-password-form.component.html',
  styleUrl: './forgot-password-form.component.scss'
})
export class ForgotPasswordFormComponent {
  readonly forgotPasswordForm = new FormGroup({
    email: new FormControl<string>('', {
      validators: [
        Validators.required,
        Validators.email
      ]
    }),
  });

  readonly onSubmit = output<any>();
  readonly enabled = model<boolean>(true);
  readonly isLoading = model.required<boolean>();
  readonly id = uuidv4();

  readonly today = new Date();

  readonly formWatched = watchFormRecursively(this.forgotPasswordForm);

  constructor(private readonly messageService: MessageService) {
    effect(() => {
      if (this.enabled()) {
        this.forgotPasswordForm.enable();
      } else {
        this.forgotPasswordForm.disable();
      }
    });
  }

  resetForm(): void {
    this.forgotPasswordForm.reset();
    this.isLoading.set(false);
  }

  submitForm(): void {
    this.isLoading.set(true);

    if (this.forgotPasswordForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Preencha todos os campos corretamente!',
        life: 4000
      });

      this.isLoading.set(false);
      return;
    }

    sanitizeFields(this.forgotPasswordForm);
    this.onSubmit.emit(this.forgotPasswordForm.value);
  }
}
